import { Row, Col } from 'react-bootstrap';
import SectionWithTwoCards from '../../../Components/sectionsWithTwoCards/SectionWithTwoCards';
import { HeadingDesc, SectionHeadingSmall } from '../../../Components/Headings';
import SimpleCard from '../../../Components/Card/simpleCard/SimpleCard';
import { RightArrowWithBorder } from '../../../Components/icons';
import { AnchorLink } from '../../../Components/button';
import img1 from '../../../assets/images/png/bookappointment.png';
import img2 from '../../../assets/images/png/instant-consultant.png';
import './consultWithDoctor.css';

function ConsultWithDoctor() {
  return (
    <section className="consultWithDoctor">
      <SectionWithTwoCards
        leftCardContent={<LeftCardContent />}
        rightCardContent={<RightCardContent />}
      />
    </section>
  );
}

function RightCardContent() {
  return (
    <SimpleCard bgColor="#FEF1A0">
      <Row>
        <Col md={8}>
          <div className="content_container">
            <SectionHeadingSmall
              text="Book instant consultation with a doctor right away - in just three clicks!"
              color="#313131"
            />
            <HeadingDesc text="Get Health tips, diet advice and nutritional guidance" />
          </div>
          <div className="btn_container">
            <RightArrowWithBorder />
            <AnchorLink text="learn more" />
          </div>
        </Col>
        <Col md={4}>
          <div className="instantConsult">
            <img src={img2} alt="instantConsultant" />
          </div>
        </Col>
      </Row>
    </SimpleCard>
  );
}

function LeftCardContent() {
  return (
    <SimpleCard bgColor="#BEF5F1">
      <Row>
        <Col md={9}>
          <div className="content_container">
            <SectionHeadingSmall
              text="Find And Book Appointment With Verified Doctors - Online or book a visit!"
              color="#313131"
            />
            <HeadingDesc text="16000+ PMC Verified Doctors" />
            <div className="btn_container">
              <RightArrowWithBorder />
              <AnchorLink text="VIEW ALL DOCTORS" />
            </div>
          </div>
        </Col>
        <Col md={2}>
          <div className="bookAppointment">
            <img src={img1} alt="bookAppointment" />
          </div>
        </Col>
      </Row>
    </SimpleCard>
  );
}

export default ConsultWithDoctor;
